//@flow

import styled from "styled-components"

export default styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(rgba(6, 22, 36, 0) 90%, rgba(6, 22, 36, 1)) 94%;
  z-index: 2;
`



// WEBPACK FOOTER //
// ./src/Kiosk/LocationsModal/MapOverlay.js